import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import type { SVGProps } from 'react';
const SvgLockIconZoomedIn = props => {
  const $ = _c(3);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <path fill="currentColor" d="M11.875 120.5q-4.692 0-8.03-3.354Q.505 113.792.5 109.071V51.929q0-4.715 3.344-8.069 3.345-3.354 8.031-3.36h5.688V29.071q0-11.856 8.32-20.211T46 .5Q57.796.494 66.122 8.86t8.316 20.211V40.5h5.687q4.692 0 8.036 3.36 3.345 3.36 3.339 8.069v57.142q0 4.715-3.339 8.075t-8.036 3.354zm0-11.429h68.25V51.929h-68.25zM46 91.929q4.692 0 8.036-3.355 3.345-3.354 3.339-8.074t-3.339-8.069T46 69.071q-4.704-.01-8.03 3.36-3.329 3.372-3.345 8.069t3.344 8.074Q41.33 91.952 46 91.93M28.938 40.5h34.125V29.071q0-7.143-4.977-12.142-4.976-5-12.086-5t-12.086 5q-4.977 5-4.977 12.142z" />;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== props) {
    t1 = <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 92 121" {...props}>{t0}</svg>;
    $[1] = props;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};
export default SvgLockIconZoomedIn;